<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} opción
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Opción -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="opción" rules="required|integer" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.option"
                    :error-messages="errors"
                    label="Opción"
                    type="number"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="mensaje menú" rules="required|max:25" v-slot="{ errors }">
                  <v-textarea
                    v-model="payload.message"
                    :error-messages="errors"
                    label="Mensaje menú"
                    rounded
                    filled
                    class="rounded-lg"
                    counter="25"
                    maxlength="25"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje de regreso -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje de regreso al menú anterior"
                  rules="required|max:70"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.option_return"
                    :error-messages="errors"
                    label="Mensaje de regreso al menú anterior"
                    rounded
                    filled
                    class="rounded-lg"
                    counter="70"
                    maxlength="70"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Redirección -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="es grupo" rules="required" v-slot="{ errors }">
                  <v-radio-group v-model="payload.redirection" :error-messages="errors" row>
                    <template v-slot:label> Redirección </template>
                    <v-radio label="Sí" :value="1"></v-radio>
                    <v-radio label="No" :value="0"></v-radio>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>

              <!-- Cola -->

              <v-col v-if="payload.redirection === 1" cols="12">
                <ValidationProvider name="Cola" rules="required" v-slot="{ errors }">
                  <v-autocomplete
                    :disabled="isLoading"
                    :items="queueList"
                    item-text="name"
                    item-value="id"
                    required
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Cola"
                    name="number"
                    prepend-inner-icon="mdi-numeric"
                    color="blue-grey"
                    v-model="payload.queue_id"
                    :error-messages="errors"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-on="on" v-bind="attrs" class="pl-3">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>

              <!-- Notificación -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="es grupo" rules="required" v-slot="{ errors }">
                  <v-radio-group v-model="payload.notification" :error-messages="errors" row>
                    <template v-slot:label> Notificación </template>
                    <v-radio label="Sí" :value="1"></v-radio>
                    <v-radio label="No" :value="0"></v-radio>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>

              <!-- Texto de notificación -->
              <v-col cols="12" class="pb-0" v-if="payload.notification === 1">
                <ValidationProvider name="texto de notificación" rules="required" v-slot="{ errors }">
                  <v-textarea
                    v-model="payload.notification_text"
                    :error-messages="errors"
                    label="Texto de notificación"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Collect data -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="collect data" rules="" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.collect_data_id"
                    :items="collectDataList"
                    :error-messages="errors"
                    item-text="title"
                    item-value="id"
                    label="Collect data"
                    filled
                    rounded
                    clearable
                    class="rounded-lg"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-on="on" v-bind="attrs" class="pl-3">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.title + " " }}
                            </v-list-item-title>

                            <!-- <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle> -->
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" :disabled="isLoading" class="px-8" color="success" rounded large>
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    parentId: {
      type: Number,
      default: null,
    },

    data: {
      type: Object,
      default: {},
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      queueList: [],
      collectDataList: [],
      clientList: [],
      payload: {
        option: null,
        message: "",
        option_return: "",
        notification_text: "",
        redirection: null,
        notification: "",

        queue_id: null,
        bot_id: null,
        collect_data_id: null,
      },
    };
  },

  computed: {
    isEditMode() {
      return !!this.dataToEdit.id;
    },
  },

  created() {
    this.getSelectsInfo();
    this.payload = { ...this.dataToEdit, bot_id: this.parentId };
  },

  watch: {
    parentId(val) {
      this.payload.bot_id = val;
    },
  },

  methods: {
    resetform() {
      this.payload.option = null;
      this.payload.message = "";
      this.payload.option_return = "";
      this.payload.notification_text = "";
      this.payload.redirection = null;
      this.payload.notification = "";
      this.payload.queue_id = null;
      this.payload.bot_id = null;
      this.payload.collect_data_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data, this.isEditMode);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = [`/clients/index_whatsapp`, "/collect_data_survey"];

      await axios
        .all(endpoints.map((endpoint) => PbxHttpClient.get(endpoint)))
        .then((res) => {
          this.queueList = res[0].data.data;
          this.collectDataList = res[1].data;
          // console.log("Listo", res);
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      // const { id, ...payload } = this.payload;

      this.payload = Object.assign({}, this.payload, this.data);

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/whatsapps/options_bot/${id}`, payload)
          : await PbxHttpClient.post("/whatsapps/options_bot", payload);
        this.closeDialog(data.option);

        this.$snotify.success(`Opción ${this.isEditMode ? "actualizado" : "creado"} con éxito.`, "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }

      this.isLoading = false;
    },
  },
};
</script>
